/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Dictionaries.scss';
import ModalAlert from '../../../ModalAlert';

import { getDistrictData } from '../../../../../actions/district';
import { addDict, deleteDict, addDictVals, addDictAttrs } from '../../../../../actions/dictionaries';

const AttrRow = (props) => {
  const nr = props.nr;
  const type = 'attr';
  return (
    <tr>
      <td>
        <select className="form-control" value={props.attrName} onChange={(e) => props.onChangeAttribute(e, nr)}>
          {props.isNew ? <option value="" /> : null }
          {props.layer.attrs.map((v, i) => <option key={i} value={v.nazwa}>{v.nazwa}</option>)}
        </select>
      </td>
      <td><input className="form-control" type="text" value={props.newAttrname} onChange={(e) => props.onChangeInput(e, nr, type, 'newAttrname')} /></td>
      <td><input className="form-control" type="text" value={props.desc} onChange={(e) => props.onChangeInput(e, nr, type, 'desc')} /></td>
      <td><button type="button" className="btn btn-danger" onClick={(e) => props.onDelete(e, nr)}>Usuń</button></td>
    </tr>
  );
};

const ValRow = (props) => {
  const nr = props.nr;
  const type = 'val';
  return (
    <tr>
      <td>
        <select className="form-control" value={props.attrName} onChange={(e) => props.onChangeAttribute(e, nr)}>
          {props.isNew ? <option value="" /> : null }
          {props.layer.attrs.map((v, i) => <option key={i} value={v.nazwa}>{v.nazwa}</option>)}
        </select>
      </td>
      <td><input className="form-control" type="text" value={props.value} onChange={(e) => props.onChangeInput(e, nr, type, 'value')} /></td>
      <td><input className="form-control" type="text" value={props.newValue} onChange={(e) => props.onChangeInput(e, nr, type, 'newValue')} /></td>
      <td><input className="form-control" type="text" value={props.desc} onChange={(e) => props.onChangeInput(e, nr, type, 'desc')} /></td>
      <td><button type="button" className="btn btn-danger" onClick={(e) => props.onDelete(e, nr)}>Usuń</button></td>
    </tr>
  );
};

const Dictionary = (props) => {
  return (
    <div>
      <div className="row">
        {props.type === 'val' ? <h4>Słownik wartości</h4> : <h4>Słownik atrybutów</h4> }
        <div className="form-inline">
          <label className="col-sm-3" htmlFor="selectLayer">Nazwa słownika</label>
          <input type="text" className="form-control" value={props.name} onChange={(e) => props.onChangeName(e)} />
        </div>
        <br />
      </div>
      <div className="row">
        <table className="table">
          <thead>
            {props.type === 'val' ? (
              <tr>
                <th>Atrybut</th>
                <th>Wartość</th>
                <th>Nowa wartość</th>
                <th>Opis</th>
                <th>Akcja</th>
              </tr>
            ) : null}
            {props.type === 'attr' ? (
              <tr>
                <th>Atrybut</th>
                <th>Nowa nazwa</th>
                <th>Opis</th>
                <th>Akcja</th>
              </tr>
            ) : null}
          </thead>
          <tbody>
            {props.data.map((v, i) => {
              return (props.type === 'attr') ? (
                <AttrRow
                  isNew={props.isNew}
                  {...v}
                  key={i}
                  nr={i}
                  layer={props.layer}
                  onDelete={props.onDelete}
                  onChangeAttribute={props.onChangeAttribute}
                  onChangeInput={props.onChangeInput}
                />
                ) : (
                  <ValRow
                    isNew={props.isNew}
                    {...v}
                    nr={i}
                    key={i}
                    layer={props.layer}
                    onDelete={props.onDelete}
                    onChangeAttribute={props.onChangeAttribute}
                    onChangeInput={props.onChangeInput}
                  />);
            })}
          </tbody>
        </table>
        <button onClick={() => props.onAdd()} type="button" className="btn btn-success">Dodaj element</button>
        <br /><br />
        <button type="button" onClick={() => props.saveDict()} className="btn btn-info">Zapisz</button>
        {!props.isNew ? <button onClick={() => props.onDelete()} type="button" className="btn btn-danger">Usuń słownik</button> : null}
        {props.isNew ? <button type="button" className="btn btn-warning">Anuluj</button> : null}
      </div>
    </div>
  );
};

class Dictionaries extends React.Component {
  constructor(props) {
    super(props);
    const hasValDict = this.props.district.layers && this.props.district.layers.length > 0 ? _.find(this.props.district.layers[0].dicts, (o) => o.type === 'val') : null;
    const hasAttrDict = this.props.district.layers && this.props.district.layers.length > 0 ? _.find(this.props.district.layers[0].dicts, (o) => o.type === 'attr') : null;
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
      currentLayer: 0,
      isAddingNewValDict: false,
      isAddingNewAttrDict: false,
      currentAttrDict: hasAttrDict,
      currentValDict: hasValDict,
    };
  }

  onLayerChange = (e) => {
    this.setState({ currentLayer: e.target.selectedIndex, isStyleChanged: false, isAddingNewValDict: false, isAddingNewAttrDict: false }, () => {
      const hasValDict = _.find(this.props.district.layers[this.state.currentLayer].dicts, (o) => o.type === 'val');
      const hasAttrDict = _.find(this.props.district.layers[this.state.currentLayer].dicts, (o) => o.type === 'attr');
      (hasAttrDict) ? this.setState({ currentAttrDict: hasAttrDict }) : this.setState({ currentAttrDict: null });
      (hasValDict) ? this.setState({ currentValDict: hasValDict }) : this.setState({ currentValDict: null });
    });
  }

  onChangeValDictName = (e) => this.setState({ currentValDict: { ...this.state.currentValDict, name: e.target.value } });
  onChangeAttrDictName = (e) => this.setState({ currentAttrDict: { ...this.state.currentAttrDict, name: e.target.value } });

  onAddNewValDict = () => this.setState({ isAddingNewValDict: true, currentValDict: {
    layer: this.props.district.layers[this.state.currentLayer].name,
    name: '',
    prefix: this.props.district.prefix,
    type: 'val',
    data: [],
  } });
  onAddNewAttrDict = () => this.setState({ isAddingNewAttrDict: true, currentAttrDict: {
    layer: this.props.district.layers[this.state.currentLayer].name,
    name: '',
    prefix: this.props.district.prefix,
    type: 'attr',
    data: [],
  } });

  onDeleteVal = (e, i) => {
    this.setState({ currentValDict: {
      ...this.state.currentValDict,
      data: _.filter(this.state.currentValDict.data, (o, index) => index !== i) } });
  }
  onDeleteAttr = (e, i) => {
    this.setState({ currentAttrDict: {
      ...this.state.currentAttrDict,
      data: _.filter(this.state.currentAttrDict.data, (o, index) => index !== i) } });
  }

  onAddVal = () => {
    this.setState({ currentValDict: {
      ...this.state.currentValDict,
      data: this.state.currentValDict.data.concat([
        {
          attrName: '',
          value: '',
          newValue: '',
          desc: '',
        },
      ]) } });
  }

  onAddAttr = () => {
    this.setState({ currentAttrDict: {
      ...this.state.currentAttrDict,
      data: this.state.currentAttrDict.data.concat([
        {
          attrName: '',
          newAttrName: '',
          desc: '',
        },
      ]) } });
  }

  onChangeAttrAttribute = (e, i) => {
    this.setState({ currentAttrDict: {
      ...this.state.currentAttrDict,
      data: _.filter(this.state.currentAttrDict.data, (o, index) => {
        if (index === i) {
          o.attrName = e.target.value;
          return o;
        }
        return o;
      }) } });
  }

  onChangeValAttribute = (e, i) => {
    this.setState({ currentValDict: {
      ...this.state.currentValDict,
      data: _.filter(this.state.currentValDict.data, (o, index) => {
        if (index === i) {
          o.attrName = e.target.value;
          return o;
        }
        return o;
      }) } });
  }

  onChangeInput = (e, i, type, attr) => {
    if (type === 'val') {
      this.setState({ currentValDict: {
        ...this.state.currentValDict,
        data: _.filter(this.state.currentValDict.data, (o, index) => {
          if (index === i) {
            o[attr] = e.target.value;
            return o;
          }
          return o;
        }) } });
    } else {
      this.setState({ currentAttrDict: {
        ...this.state.currentAttrDict,
        data: _.filter(this.state.currentAttrDict.data, (o, index) => {
          if (index === i) {
            o[attr] = e.target.value;
            return o;
          }
          return o;
        }) } });
    }
  }

  dismissModal = () => this.setState({ showModal: false });

  saveAttrDict = () => {
    if (this.state.currentAttrDict.data.length === 0 || !this.state.currentAttrDict.name) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Brak nazwy słownika lub brak wypełnionych pól.', showModal: true });
    } else {
      this.props.addDict(this.props.district.prefix, this.state.currentAttrDict, this.props.district.layers[this.state.currentLayer].name).then((resp) => {
        this.props.addDictAttrs(this.props.district.prefix, this.state.currentAttrDict, this.props.district.layers[this.state.currentLayer].name).then((response) => {
          this.setState({ modalTitle: 'Status', modalBody: response.message, showModal: true });
          this.props.getDistrictData(this.props.district.prefix).then(() => {
            const hasValDict = _.find(this.props.district.layers[0].dicts, (o) => o.type === 'val');
            const hasAttrDict = _.find(this.props.district.layers[0].dicts, (o) => o.type === 'attr');
            this.setState({ currentLayer: 0, currentAttrDict: hasAttrDict, currentValDict: hasValDict });
          });
        });
      });
    }
  }

  saveValDict = () => {
    if (this.state.currentValDict.data.length === 0 || !this.state.currentValDict.name) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Brak nazwy słownika lub brak wypełnionych pól.', showModal: true });
    } else {
      this.props.addDict(this.props.district.prefix, this.state.currentValDict, this.props.district.layers[this.state.currentLayer].name).then((resp) => {
        this.props.addDictVals(this.props.district.prefix, this.state.currentValDict, this.props.district.layers[this.state.currentLayer].name).then((response) => {
          this.setState({ modalTitle: 'Status', modalBody: response.message, showModal: true });
          this.props.getDistrictData(this.props.district.prefix).then(() => {
            const hasValDict = _.find(this.props.district.layers[0].dicts, (o) => o.type === 'val');
            const hasAttrDict = _.find(this.props.district.layers[0].dicts, (o) => o.type === 'attr');
            this.setState({ currentLayer: 0, currentAttrDict: hasAttrDict, currentValDict: hasValDict });
          });
        });
      });
    }
  }

  deleteDictionary = () => {
    const dict = (this.state.currentAttrDict) ? this.state.currentAttrDict : this.state.currentValDict;
    this.props.deleteDict(this.props.district.prefix, dict).then((resp) => {
      this.setState({ modalTitle: 'Status', modalBody: resp.message, showModal: true });
    }).then(() => {
      this.forceUpdate();
      this.props.getDistrictData(this.props.district.prefix).then(() => {
        const hasValDict = _.find(this.props.district.layers[0].dicts, (o) => o.type === 'val');
        const hasAttrDict = _.find(this.props.district.layers[0].dicts, (o) => o.type === 'attr');
        this.setState({ currentLayer: 0, currentAttrDict: hasAttrDict, currentValDict: hasValDict });
      });
    });
  }

  renderValDict = () => {
    return (
      <Dictionary
        {...this.state.currentValDict}
        onChangeName={(e) => this.onChangeValDictName(e)}
        layer={this.props.district.layers[this.state.currentLayer]}
        onAdd={() => this.onAddVal()}
        onDelete={(e, i) => this.onDeleteVal(e, i)}
        onChangeAttribute={(e, i) => this.onChangeValAttribute(e, i)}
        onChangeInput={(e, i, type, attr) => this.onChangeInput(e, i, type, attr)}
        saveDict={() => this.saveValDict()}
        onDelete={() => this.deleteDictionary()}
      />);
  }

  renderAttrDict = () => {
    return (
      <Dictionary {...this.state.currentAttrDict}
        onChangeName={(e) => this.onChangeAttrDictName(e)}
        layer={this.props.district.layers[this.state.currentLayer]}
        onAdd={() => this.onAddAttr()}
        onDelete={(e, i) => this.onDeleteAttr(e, i)}
        onChangeAttribute={(e, i) => this.onChangeAttrAttribute(e, i)}
        onChangeInput={(e, i, type, attr) => this.onChangeInput(e, i, type, attr)}
        saveDict={() => this.saveAttrDict()}
        onDelete={() => this.deleteDictionary()}
      />);
  }

  renderNewAttrDict = () => {

    return (
      <Dictionary
        isNew
        {...this.state.currentAttrDict}
        onChangeName={(e) => this.onChangeAttrDictName(e)}
        layer={this.props.district.layers[this.state.currentLayer]}
        onAdd={() => this.onAddAttr()}
        onDelete={(e, i) => this.onDeleteAttr(e, i)}
        onChangeAttribute={(e, i) => this.onChangeAttrAttribute(e, i)}
        onChangeInput={(e, i, type, attr) => this.onChangeInput(e, i, type, attr)}
        saveDict={() => this.saveAttrDict()}
      />);
  }

  renderNewValDict = () => {
    return (
      <Dictionary
        isNew
        {...this.state.currentValDict}
        onChangeName={(e) => this.onChangeValDictName(e)}
        layer={this.props.district.layers[this.state.currentLayer]}
        onAdd={() => this.onAddVal()}
        onDelete={(e, i) => this.onDeleteVal(e, i)}
        onChangeAttribute={(e, i) => this.onChangeValAttribute(e, i)}
        onChangeInput={(e, i, type, attr) => this.onChangeInput(e, i, type, attr)}
        saveDict={() => this.saveValDict()}
      />);
  }

  render() {
    const { isAddingNewValDict, isAddingNewAttrDict } = this.state;
    return this.props.district.layers && this.props.district.layers.length > 0 ? (
      <div className="container-fluid">
        <div className="row">
          <div className="form-inline">
            <label className="col-sm-3" htmlFor="selectLayer">Warstwa</label>
            <select name="selectLayer" onChange={(e) => this.onLayerChange(e)} className="form-control" value={this.props.district.layers[this.state.currentLayer].name}>
              {this.props.district.layers.map((v, i) => {
                return <option key={i} value={v.name}> {String.prototype.normalizeLayerName(v.name)}</option>;
              })}
            </select>
          </div>
          <br />
        </div>
        <hr />
        <div className="row">
          {(this.state.currentValDict && !isAddingNewValDict) ? (this.renderValDict()) : (
            (!isAddingNewValDict) ? (<button onClick={() => this.onAddNewValDict()} type="button" className="btn btn-info">Dodaj słownik wartości</button>) : null
          )}
          {isAddingNewValDict ? this.renderNewValDict() : null}
        </div>
        <hr />
        <div className="row">
          {(this.state.currentAttrDict && !isAddingNewAttrDict) ? this.renderAttrDict() : (
            (!isAddingNewAttrDict) ? (
              <button onClick={() => this.onAddNewAttrDict()} type="button" className="btn btn-info">Dodaj słownik atrybutów</button>
            ) : null)}
          {isAddingNewAttrDict ? this.renderNewAttrDict() : null}
        </div>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
      </div>
    ) : <h2>Nie opublikowano żadnej warstwy do tej pory</h2>;
  }
}

const mapState = (state) => ({
  district: state.district.district,
});

const mapDispatch = {
  addDict,
  deleteDict,
  getDistrictData,
  addDictVals,
  addDictAttrs,
};

export default withStyles(s)(connect(mapState, mapDispatch)(Dictionaries));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/Dictionaries/Dictionaries.js